// ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect unauthenticated users to login and preserve intended route
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If adminOnly is true, verify user role
  if (adminOnly && user?.role !== 'admin' && user?.role !== 'super-admin') {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h3>🚫 Access Denied</h3>
        <p>You must be an admin to view this page.</p>
      </div>
    );
  }

  // Render the child component if checks pass
  return children;
};

export default ProtectedRoute;
